import "~/app/publicPath";
import Vue from "vue";
import Vuex from "vuex";
import NotificationService from "ceres/app/services/NotificationService";
import TranslationService from "ceres/app/services/TranslationService";
import "bootstrap";
import "owl.carousel";
import { createApp, beforeCreate } from "./app";
import "custom-event-polyfill";
import { initClientListeners, initClientStore, createStore } from "ceres/app/store";
import { initListener } from "ceres/app/services/ApiService";
import { mount } from "ceres/mount";
import "ceres/app/jQuery";

Vue.prototype.$mount = mount;

// defines if the render location is the client
App.isSSR = false;
App.isSSREnabled = App.config.log.performanceSsr;

beforeCreate();

window.createApp = (selector) =>
{
    // client-specific bootstrapping logic...
    const app = createApp({
        template: "#ssr-script-container"
    }, store);

    app.$mount(selector, true);
    window.vueApp = app;

    initListener();

    initClientListeners(store);
    initClientStore(store);
};

const store = createStore();

if (window.__INITIAL_STATE__)
{
    store.replaceState(window.__INITIAL_STATE__);
}

window.Vue = Vue;
window.Vuex = Vuex;
window.NotificationService = NotificationService;
window.ceresTranslate = TranslationService.translate;
window.vueEventHub = new Vue();
window.ceresStore = store;

import "ceres/app/main";
